import mutations from './treatmentStatisticReferral.mutations';
import actions from './treatmentStatisticReferral.actions';
import getters from './treatmentStatisticReferral.getters';

import initialState from './defaultState';

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}